import styled from 'styled-components'
export const MenuStyleItem = styled.li`
  margin-bottom: 7px;
  padding-left: 26px;
  list-style: none;
  display:inline;
`;